import { cx } from 'linaria';
import React, { useState } from 'react';
import {
  DATA_QA_UNIQUE_OFFER_CONTAINER,
  DATA_QA_UNIQUE_OFFER_ITEMS_GRID,
  DATA_QA_UNIQUE_OFFER_TITLE,
} from './constants';
import { UniqueOfferModalType, UniqueOfferType } from 'features/page-model';
import { Typography } from 'fronton-react';
import { UniqueOfferItem } from './unique-offer-item';
import { sectionDivider } from 'pages/product-details/styles';
import { gridContainer, uniqueOfferContainer, uniqueOfferTitle } from './styles';
import { UniqueOfferModal } from './unique-offer-modal';

type UniqueOfferProps = {
  data: UniqueOfferType;
};

export const UniqueOffer: React.FC<UniqueOfferProps> = ({ data }) => {
  const items = data?.items || [];

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<UniqueOfferModalType | null>(null);

  if (!items.length) return null;

  return (
    <>
      <div className={cx(sectionDivider, uniqueOfferContainer)} data-qa={DATA_QA_UNIQUE_OFFER_CONTAINER}>
        <Typography
          className={uniqueOfferTitle}
          color="text-primary"
          variant="h3"
          as="h2"
          data-qa={DATA_QA_UNIQUE_OFFER_TITLE}
        >
          {data?.title}
        </Typography>

        <div
          className={gridContainer}
          data-items-count={items.length}
          data-qa={DATA_QA_UNIQUE_OFFER_ITEMS_GRID}
        >
          {items.map((el, index) => (
            <UniqueOfferItem
              setModalOpen={setModalOpen}
              setModalData={setModalData}
              key={`${el.text}-${index}`}
              data={el}
            />
          ))}
        </div>
      </div>

      <UniqueOfferModal data={modalData} modalVisibility={modalOpen} setModalVisibility={setModalOpen} />
    </>
  );
};
